var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountOverviewShippingAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5378 8.69922C22.6238 8.91406 22.6667 9.12891 22.6667 9.34375V20.6875C22.6667 21.8477 21.7214 22.75 20.6042 22.75H2.72925C1.56909 22.75 0.666748 21.8477 0.666748 20.6875V9.34375C0.666748 9.12891 0.666748 8.91406 0.752686 8.69922L2.94409 2.16797C3.2019 1.35156 3.97534 0.75 4.87769 0.75H18.4128C19.3152 0.75 20.0886 1.35156 20.3464 2.16797L22.5378 8.69922ZM2.04175 9.34375H10.9792V2.125H4.87769C4.5769 2.125 4.31909 2.33984 4.23315 2.59766L2.04175 9.12891C2.04175 9.21484 2.04175 9.30078 2.04175 9.34375ZM21.2917 20.6875V10.7188H2.04175V20.6875C2.04175 21.0742 2.34253 21.375 2.72925 21.375H20.6042C20.948 21.375 21.2917 21.0742 21.2917 20.6875ZM21.2917 9.34375C21.2917 9.25781 21.2488 9.21484 21.2488 9.12891L19.0574 2.59766C18.9714 2.33984 18.7136 2.125 18.4128 2.125H12.3542V9.34375H21.2917Z",
    fill: "#CE0E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountOverviewShippingAddress);
export default __webpack_public_path__ + "static/media/AccountOverviewShippingAddress.f84e8065092e4606abdc427c579a74b1.svg";
export { ForwardRef as ReactComponent };